import React from 'react';

function Footer() {
  return (
    <div className="mx-auto w-full text-center">
      <p className="text-xl">Made with ❤️ by <a className="hover:text-gray-400" href="https://codgen.pk" target="_blank" rel="noreferrer"> Codgen Solutions </a></p>
    </div>
  )
}

export default Footer;